import Accounts from "@/commons/services/Accounts";
import AdmissionApplicationTemplates from "@/commons/services/AdmissionApplicationTemplates";
import AdmissionJudgementTemplates from "@/commons/services/AdmissionJudgementTemplates";
import Authorization from "@/commons/services/Authorization";
import LatestCareimageDate from "@/commons/services/LatestCareimageDate";
import CalendarEvents from "@/commons/services/CalendarEvents";
import Careimages from "@/commons/services/Careimages";
import CareimageStatuses from "@/commons/services/CareimageStatuses";
import CommonService from "@/commons/services/CommonService";
import ContactMessages from "@/commons/services/ContactMessages";
import Contacts from "@/commons/services/Contacts";
import DraftMessages from "@/commons/services/DraftMessages";
import Events from "@/commons/services/Events";
import EventReplies from "@/commons/services/EventReplies";
import ExistS3Files from "@/commons/services/ExistS3Files";
import Facilities from "@/commons/services/Facilities";
import Families from "@/commons/services/Families";
import FamilySafetyConfirmsTemplates from "@/commons/services/FamilySafetyConfirmsTemplates";
import FamilySafetyConfirmMasters from "@/commons/services/FamilySafetyConfirmMasters";
import FollowerMessages from "@/commons/services/FollowerMessages";
import Followers from "@/commons/services/Followers";
import FunctionHistories from "@/commons/services/FunctionHistories";
import GoodTreeFiles from "@/commons/services/GoodTreeFiles";
import IMedicFiles from "@/commons/services/IMedicFiles";
import InspectionReservations from "@/commons/services/InspectionReservations";
import MailFamilies from "@/commons/services/MailFamilies";
import MailOtherUserGroupMembers from "@/commons/services/MailOtherUserGroupMembers";
import Manuals from "@/commons/services/Manuals";
import Meeting from "@/commons/services/Meeting";
import Messages from "@/commons/services/Messages";
import MessageSettings from "@/commons/services/MessageSettings";
import MessagesInFamily from "@/commons/services/MessagesInFamily";
import MoveRoomSchedules from "@/commons/services/MoveRoomSchedules";
import NotificationRoomSchedules from "@/commons/services/NotificationRoomSchedules";
import Notifications from "@/commons/services/Notifications";
import OnlineReservations from "@/commons/services/OnlineReservations";
import OnlineReservationSchedules from "@/commons/services/OnlineReservationSchedules";
import OnlineReservationSettings from "@/commons/services/OnlineReservationSettings";
import OpinionMessages from "@/commons/services/OpinionMessages";
import Opinions from "@/commons/services/Opinions";
import OtherOfficeAcceptanceRequests from "@/commons/services/OtherOfficeAcceptanceRequests";
import OtherOfficeAcceptanceRequestReplies from "@/commons/services/OtherOfficeAcceptanceRequestReplies";
import OtherOfficeConnections from "@/commons/services/OtherOfficeConnections";
import OtherOfficeMessages from "@/commons/services/OtherOfficeMessages";
import OtherOfficeOnlineMeetings from "@/commons/services/OtherOfficeOnlineMeetings";
import OtherOfficeReplyMessages from "@/commons/services/OtherOfficeReplyMessages";
import OtherOfficeRoomSchedules from "@/commons/services/OtherOfficeRoomSchedules";
import OtherUserGroupMembers from "@/commons/services/OtherUserGroupMembers";
import OtherUserGroupMessages from "@/commons/services/OtherUserGroupMessages";
import OtherUserGroups from "@/commons/services/OtherUserGroups";
import OtherUserGroupSendMessageReadCounts from "@/commons/services/OtherUserGroupSendMessageReadCounts";
import OtherUserGroupSendMessageReadMembers from "@/commons/services/OtherUserGroupSendMessageReadMembers";
import OtherUserGroupSendMessageReplies from "@/commons/services/OtherUserGroupSendMessageReplies";
import OtherUserGroupSendMessageRepliesMembers from "@/commons/services/OtherUserGroupSendMessageRepliesMembers";
import OtherUserGroupTypeMembers from "@/commons/services/OtherUserGroupTypeMembers";
import OtherUserGroupTypes from "@/commons/services/OtherUserGroupTypes";
import OtherUserOpinionMessages from "@/commons/services/OtherUserOpinionMessages";
import OtherUserOpinions from "@/commons/services/OtherUserOpinions";
import OtherUserSafetyConfirmMasters from "@/commons/services/OtherUserSafetyConfirmMasters";
import OtherUserSafetyConfirmsTemplates from "@/commons/services/OtherUserSafetyConfirmsTemplates";
import Outings from "@/commons/services/Outings";
import OutingSettings from "@/commons/services/OutingSettings";
import Pictures from "@/commons/services/Pictures";
import PlanRequests from "@/commons/services/PlanRequests";
import Plans from "@/commons/services/Plans";
import Questionnaires from "@/commons/services/Questionnaires";
import RecruitmentContacts from "@/commons/services/RecruitmentContacts";
import RegionMasters from "@/commons/services/RegionMasters";
import ReservableSchedules from "@/commons/services/ReservableSchedules";
import ReservableOnlineSchedules from "@/commons/services/ReservableOnlineSchedules";
import Reservations from "@/commons/services/Reservations";
import ReservationSchedules from "@/commons/services/ReservationSchedules";
import ReservationScheduleTemplates from "@/commons/services/ReservationScheduleTemplates";
import ReservationSettings from "@/commons/services/ReservationSettings";
import ResidentGroupMembers from "@/commons/services/ResidentGroupMembers";
import ResidentGroups from "@/commons/services/ResidentGroups";
import Residents from "@/commons/services/Residents";
import Rooms from "@/commons/services/Rooms";
import RoomsSchedules from "@/commons/services/RoomsSchedules";
import RoomScheduleSettings from "@/commons/services/RoomScheduleSettings";
import S3Locations from "@/commons/services/S3Locations";
import S3Uploads from "@/commons/services/S3Uploads";
import S3Url from "@/commons/services/S3Url";
import SafetyConfirmReplyMessages from "@/commons/services/SafetyConfirmReplyMessages";
import SafetyConfirmFacilityStatuses from "@/commons/services/SafetyConfirmFacilityStatuses";
import SafetyConfirms from "@/commons/services/SafetyConfirms";
import SafetyConfirmResidentStatuses from "@/commons/services/SafetyConfirmResidentStatuses";
import SendDocuments from "@/commons/services/SendDocuments";
import SendDocumentTemplates from "@/commons/services/SendDocumentTemplates";
import SendDocumentCategories from "@/commons/services/SendDocumentCategories";
import SendMessages from "@/commons/services/SendMessages";
import SendMailMessages from "@/commons/services/SendMailMessages";
import SendMessageGroupMembers from "@/commons/services/SendMessageGroupMembers";
import SendMessageGroups from "@/commons/services/SendMessageGroups";
import SendOtherUserMailMessages from "@/commons/services/SendOtherUserMailMessages";
import SendMessageReadCounts from "@/commons/services/SendMessageReadCounts";
import SendMessageReadFamilies from "@/commons/services/SendMessageReadFamilies";
import SendMessageReplies from "@/commons/services/SendMessageReplies";
import SendMessageRepliesFamilies from "@/commons/services/SendMessageRepliesFamilies";
import SendMessageTemplates from "@/commons/services/SendMessageTemplates";
import SendSafetyConfirmMessages from "@/commons/services/SendSafetyConfirmMessages";
import SendSystemError from "@/commons/services/SendSystemError";
import StandardAccounts from "@/commons/services/StandardAccounts";
import SystemSettings from "@/commons/services/SystemSettings";
import Terminations from "@/commons/services/Terminations";
import UseMessageCounts from "@/commons/services/UseMessageCounts";
import WaiterChangeApplications from "@/commons/services/WaiterChangeApplications";
import WaiterFamilies from "@/commons/services/WaiterFamilies";
import WaiterFunctions from "@/commons/services/WaiterFunctions";
import WaiterProgressHistories from "@/commons/services/WaiterProgressHistories";
import WaiterRecruitments from "@/commons/services/WaiterRecruitments";
import WaiterLabels from "@/commons/services/WaiterLabels";
import WaiterOpinions from "@/commons/services/WaiterOpinions";
import Waiters from "@/commons/services/Waiters";
import WaiterSendMessageReadCounts from "@/commons/services/WaiterSendMessageReadCounts";
import WaiterSendMessageReplies from "@/commons/services/WaiterSendMessageReplies";
import WaiterServicePlans from "@/commons/services/WaiterServicePlans";
import Zipcloud from "@/commons/services/Zipcloud";

/**
 * Service Provider
 * API操作を行うServiceをrootVueインスタンスに持たせるためのServiceを保持する
 */

const commonService: CommonService = new CommonService();

export const provide = {
  ["AccountsService"]: new Accounts(commonService),
  ["AdmissionApplicationTemplatesService"]: new AdmissionApplicationTemplates(commonService),
  ["AdmissionJudgementTemplatesService"]: new AdmissionJudgementTemplates(commonService),
  ["LatestCareimageDateService"]: new LatestCareimageDate(commonService),
  ["CalendarEventsService"]: new CalendarEvents(commonService),
  ["CareimagesService"]: new Careimages(commonService),
  ["CareimageStatusesService"]: new CareimageStatuses(commonService),
  ["ContactMessagesService"]: new ContactMessages(commonService),
  ["ContactsService"]: new Contacts(commonService),
  ["DraftMessagesService"]: new DraftMessages(commonService),
  ["EventsService"]: new Events(commonService),
  ["EventRepliesService"]: new EventReplies(commonService),
  ["ExistS3FilesService"]: new ExistS3Files(commonService),
  ["FacilitiesService"]: new Facilities(commonService),
  ["FamiliesService"]: new Families(commonService),
  ["FamilySafetyConfirmsTemplatesService"]: new FamilySafetyConfirmsTemplates(commonService),
  ["FamilySafetyConfirmMastersService"]: new FamilySafetyConfirmMasters(commonService),
  ["FollowerMessagesService"]: new FollowerMessages(commonService),
  ["FollowersService"]: new Followers(commonService),
  ["FunctionHistoriesService"]: new FunctionHistories(commonService),
  ["GoodTreeFilesService"]: new GoodTreeFiles(commonService),
  ["IMedicFilesService"]: new IMedicFiles(commonService),
  ["InspectionReservationsService"]: new InspectionReservations(commonService),
  ["AuthorizationService"]: new Authorization(commonService),
  ["MailFamiliesService"]: new MailFamilies(commonService),
  ["MailOtherUserGroupMembersService"]: new MailOtherUserGroupMembers(commonService),
  ["ManualsService"]: new Manuals(commonService),
  ["MeetingService"]: new Meeting(commonService),
  ["MessagesService"]: new Messages(commonService),
  ["MessageSettingsService"]: new MessageSettings(commonService),
  ["MessagesInFamilyService"]: new MessagesInFamily(commonService),
  ["MoveRoomSchedulesService"]: new MoveRoomSchedules(commonService),
  ["NotificationRoomSchedulesService"]: new NotificationRoomSchedules(commonService),
  ["NotificationsService"]: new Notifications(commonService),
  ["OnlineReservationsService"]: new OnlineReservations(commonService),
  ["OnlineReservationSchedulesService"]: new OnlineReservationSchedules(commonService),
  ["OnlineReservationSettingsService"]: new OnlineReservationSettings(commonService),
  ["OpinionMessagesService"]: new OpinionMessages(commonService),
  ["OpinionsService"]: new Opinions(commonService),
  ["OtherOfficeAcceptanceRequestsService"]: new OtherOfficeAcceptanceRequests(commonService),
  ["OtherOfficeAcceptanceRequestRepliesService"]: new OtherOfficeAcceptanceRequestReplies(commonService),
  ["OtherOfficeConnectionsService"]: new OtherOfficeConnections(commonService),
  ["OtherOfficeMessagesService"]: new OtherOfficeMessages(commonService),
  ["OtherOfficeOnlineMeetingsService"]: new OtherOfficeOnlineMeetings(commonService),
  ["OtherOfficeReplyMessagesService"]: new OtherOfficeReplyMessages(commonService),
  ["OtherOfficeRoomSchedulesService"]: new OtherOfficeRoomSchedules(commonService),
  ["OtherUserGroupMembersService"]: new OtherUserGroupMembers(commonService),
  ["OtherUserGroupMessagesService"]: new OtherUserGroupMessages(commonService),
  ["OtherUserGroupsService"]: new OtherUserGroups(commonService),
  ["OtherUserGroupSendMessageReadCountsService"]: new OtherUserGroupSendMessageReadCounts(commonService),
  ["OtherUserGroupSendMessageReadMembersService"]: new OtherUserGroupSendMessageReadMembers(commonService),
  ["OtherUserGroupSendMessageRepliesService"]: new OtherUserGroupSendMessageReplies(commonService),
  ["OtherUserGroupSendMessageRepliesMembersService"]: new OtherUserGroupSendMessageRepliesMembers(commonService),
  ["OtherUserGroupTypeMembersService"]: new OtherUserGroupTypeMembers(commonService),
  ["OtherUserGroupTypesService"]: new OtherUserGroupTypes(commonService),
  ["OtherUserOpinionMessagesService"]: new OtherUserOpinionMessages(commonService),
  ["OtherUserOpinionsService"]: new OtherUserOpinions(commonService),
  ["OtherUserSafetyConfirmMastersService"]: new OtherUserSafetyConfirmMasters(commonService),
  ["OtherUserSafetyConfirmsTemplatesService"]: new OtherUserSafetyConfirmsTemplates(commonService),
  ["OutingsService"]: new Outings(commonService),
  ["OutingSettingsService"]: new OutingSettings(commonService),
  ["PicturesService"]: new Pictures(commonService),
  ["PlanRequestsService"]: new PlanRequests(commonService),
  ["PlansService"]: new Plans(commonService),
  ["QuestionnairesService"]: new Questionnaires(commonService),
  ["RecruitmentContactsService"]: new RecruitmentContacts(commonService),
  ["RegionMastersService"]: new RegionMasters(commonService),
  ["ReservableSchedulesService"]: new ReservableSchedules(commonService),
  ["ReservableOnlineSchedulesService"]: new ReservableOnlineSchedules(commonService),
  ["ReservationsService"]: new Reservations(commonService),
  ["ReservationSchedulesService"]: new ReservationSchedules(commonService),
  ["ReservationScheduleTemplatesService"]: new ReservationScheduleTemplates(commonService),
  ["ReservationSettingsService"]: new ReservationSettings(commonService),
  ["ResidentGroupMembersService"]: new ResidentGroupMembers(commonService),
  ["ResidentGroupsService"]: new ResidentGroups(commonService),
  ["ResidentsService"]: new Residents(commonService),
  ["RoomsService"]: new Rooms(commonService),
  ["RoomsSchedulesService"]: new RoomsSchedules(commonService),
  ["RoomScheduleSettingsService"]: new RoomScheduleSettings(commonService),
  ["S3LocationsService"]: new S3Locations(commonService),
  ["S3UploadsService"]: new S3Uploads(),
  ["S3UrlService"]: new S3Url(commonService),
  ["SafetyConfirmReplyMessagesService"]: new SafetyConfirmReplyMessages(commonService),
  ["SafetyConfirmFacilityStatusesService"]: new SafetyConfirmFacilityStatuses(commonService),
  ["SafetyConfirmsService"]: new SafetyConfirms(commonService),
  ["SafetyConfirmResidentStatusesService"]: new SafetyConfirmResidentStatuses(commonService),
  ["SendDocumentsService"]: new SendDocuments(commonService),
  ["SendDocumentTemplatesService"]: new SendDocumentTemplates(commonService),
  ["SendDocumentCategoriesService"]: new SendDocumentCategories(commonService),
  ["SendMessagesService"]: new SendMessages(commonService),
  ["SendMailMessagesService"]: new SendMailMessages(commonService),
  ["SendMessageGroupMembersService"]: new SendMessageGroupMembers(commonService),
  ["SendMessageGroupsService"]: new SendMessageGroups(commonService),
  ["SendOtherUserMailMessagesService"]: new SendOtherUserMailMessages(commonService),
  ["SendMessageReadCountsService"]: new SendMessageReadCounts(commonService),
  ["SendMessageReadFamiliesService"]: new SendMessageReadFamilies(commonService),
  ["SendMessageRepliesService"]: new SendMessageReplies(commonService),
  ["SendMessageRepliesFamiliesService"]: new SendMessageRepliesFamilies(commonService),
  ["SendMessageTemplatesService"]: new SendMessageTemplates(commonService),
  ["SendSafetyConfirmMessagesService"]: new SendSafetyConfirmMessages(commonService),
  ["SendSystemErrorService"]: new SendSystemError(commonService),
  ["StandardAccountsService"]: new StandardAccounts(commonService),
  ["SystemSettingsService"]: new SystemSettings(commonService),
  ["TerminationsService"]: new Terminations(commonService),
  ["UseMessageCountsService"]: new UseMessageCounts(commonService),
  ["WaiterChangeApplicationsService"]: new WaiterChangeApplications(commonService),
  ["WaiterFamiliesService"]: new WaiterFamilies(commonService),
  ["WaiterFunctionsService"]: new WaiterFunctions(commonService),
  ["WaiterLabelsService"]: new WaiterLabels(commonService),
  ["WaiterOpinionsService"]: new WaiterOpinions(commonService),
  ["WaiterProgressHistoriesService"]: new WaiterProgressHistories(commonService),
  ["WaiterRecruitmentsService"]: new WaiterRecruitments(commonService),
  ["WaitersService"]: new Waiters(commonService),
  ["WaiterSendMessageReadCountsService"]: new WaiterSendMessageReadCounts(commonService),
  ["WaiterSendMessageRepliesService"]: new WaiterSendMessageReplies(commonService),
  ["WaiterServicePlansService"]: new WaiterServicePlans(commonService),
  ["ZipcloudService"]: new Zipcloud(commonService)
};
